import { Capacitor } from "@capacitor/core";

/**
 * Pose la classe `is-native` sur <html> quand l'app tourne dans la coquille
 * Capacitor (iOS). Gate CSS des traitements réservés au natif — ex. la vitre
 * dépolie sous la barre de statut (.statusbar-scrim) — sans toucher au web.
 * Synchrone (simple lecture de plateforme) : aucune dépendance à un plugin.
 */
export function applyNativePlatformClass(): void {
  if (Capacitor.isNativePlatform()) {
    document.documentElement.classList.add("is-native");
  }
}
